import React from 'react';
import { fromJS } from 'immutable';
import { useAppSelector } from 'flow/hooks/useRedux';
import { QueueKey } from 'flow/types/EntityKeys';
import {
    selectQueueDescription,
    selectQueuePhoneNumber,
} from 'flow/selectors/queue-selectors';
import CallAdaptiveButton from 'flow/components/CallAdaptiveButton';
import PhoneNumber from 'flow/components/ui-components/PhoneNumber';
import PbxMenuIcon from 'flow/components/pbx/PbxMenuIcon';

interface Props {
    queueKey: QueueKey;
}

const QueuePhoneNumber = ({ queueKey }: Props) => {
    const queuePhoneNumber = useAppSelector((state) =>
        selectQueuePhoneNumber(state, queueKey),
    );

    const queueDescription = useAppSelector((state) =>
        selectQueueDescription(state, queueKey),
    );

    return (
        <div className="flex h-13 items-center justify-between rounded-sm p-2">
            <div className="flex items-center gap-x-3">
                <PbxMenuIcon iconKey="queuelogin" />
                <PhoneNumber number={queuePhoneNumber} />
            </div>

            {queuePhoneNumber ? (
                <CallAdaptiveButton
                    phoneNumber={queuePhoneNumber}
                    transferContact={fromJS({
                        description: queueDescription,
                        key: queueKey,
                    })}
                    bgColor={'bg-gray-200'}
                />
            ) : null}
        </div>
    );
};

export default QueuePhoneNumber;
